(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-blog-banner-filters"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ms-blog-banner-filters').forEach(function(section) {
    var select = section.querySelector('.filters-select');
    var buttons = section.querySelectorAll('.filters .btn');

    function applyFilter(value) {
      document.dispatchEvent(new CustomEvent('blog-filter-change', { detail: { tag: value } }));
    }

    buttons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        buttons.forEach(function(b) { b.classList.remove('active'); });
        this.classList.add('active');
        if (select) select.value = this.dataset.filterId;
        applyFilter(this.dataset.filterId);
      });
    });

    if (select) {
      select.addEventListener('change', function() {
        var btn = section.querySelector('.filters .btn[data-filter-id="' + this.value + '"]');
        if (btn) {
          btn.click();
        } else {
          applyFilter(this.value);
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-countdown"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var section = document.querySelector('section.ms-countdown');
    var wrapper = document.querySelector('.ms-countdown .content-wrapper[data-end]');
    if (!wrapper) return;

    var parts = (wrapper.dataset.end || '').match(/(\d{4})-(\d{2})-(\d{2})[\sT](\d{2}):(\d{2}):(\d{2})/);
    if (!parts) return;

    var endDate = new Date(+parts[1], +parts[2]-1, +parts[3], +parts[4], +parts[5], +parts[6]);

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function tick() {
      var now = new Date();

      if (now >= endDate) {
        section.style.display = 'none';
        return;
      }

      // Always count down to tonight's midnight, auto-resets each day
      var midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
      var diff = midnight - now;

      var hours = Math.floor(diff / (1000 * 60 * 60));
      var mins  = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      var secs  = Math.floor((diff % (1000 * 60)) / 1000);

      wrapper.querySelector('.hours').textContent = pad(hours);
      wrapper.querySelector('.mins').textContent  = pad(mins);
      wrapper.querySelector('.secs').textContent  = pad(secs);

      setTimeout(tick, 1000);
    }

    tick();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-post-grid"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sectionEl = document.querySelector('.ms-post-grid');
    if (!sectionEl) return;

    var postGrid = sectionEl.querySelector('.post-grid');
    if (!postGrid) return;

    function filterGrid(value) {
      var items = Array.from(postGrid.querySelectorAll('.grid-item'));

      // Sort all items by timestamp descending
      items.sort(function(a, b) {
        return parseInt(b.dataset.ts, 10) - parseInt(a.dataset.ts, 10);
      });

      // Re-append in sorted order so display order matches date order
      items.forEach(function(item) {
        postGrid.appendChild(item);
      });

      if (value === 'all') {
        items.forEach(function(item, i) {
          item.style.display = i < 21 ? '' : 'none';
        });
      } else {
        var shown = 0;
        items.forEach(function(item) {
          if (item.dataset.blog === value && shown < 21) {
            item.style.display = '';
            shown++;
          } else {
            item.style.display = 'none';
          }
        });
      }
    }

    // Set initial state to blog_1
    filterGrid(sectionEl.dataset.defaultBlog || 'all');

    document.addEventListener('blog-filter-change', function(e) {
      filterGrid(e.detail.tag);
    });

    function initSwiper() {
      var swiperEl = sectionEl.querySelector('.ms-post-swiper');
      if (!swiperEl || typeof Swiper === 'undefined') return;
      new Swiper(swiperEl, {
        slidesPerView: 1.25,
        spaceBetween: 15,
        breakpoints: {
          768: { slidesPerView: 2.15, spaceBetween: 20 }
        },
        navigation: {
          prevEl: sectionEl.querySelector('.swiper-nav-prev'),
          nextEl: sectionEl.querySelector('.swiper-nav-next')
        },
        scrollbar: {
          el: swiperEl.querySelector('.swiper-scrollbar'),
          draggable: true
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSwiper);
    } else {
      initSwiper();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-product-countdown"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var section = document.querySelector('section.ms-product-countdown');
    var wrapper = document.querySelector('.ms-product-countdown .content-wrapper[data-end]');
    if (!wrapper) return;

    var parts = (wrapper.dataset.end || '').match(/(\d{4})-(\d{2})-(\d{2})[\sT](\d{2}):(\d{2}):(\d{2})/);
    if (!parts) return;

    var endDate = new Date(+parts[1], +parts[2]-1, +parts[3], +parts[4], +parts[5], +parts[6]);

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function tick() {
      var now = new Date();

      if (now >= endDate) {
        section.style.display = 'none';
        return;
      }

      var midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
      var diff = midnight - now;

      var hours = Math.floor(diff / (1000 * 60 * 60));
      var mins  = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      var secs  = Math.floor((diff % (1000 * 60)) / 1000);

      wrapper.querySelector('.hours').textContent = pad(hours);
      wrapper.querySelector('.mins').textContent  = pad(mins);
      wrapper.querySelector('.secs').textContent  = pad(secs);

      setTimeout(tick, 1000);
    }

    tick();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-product-countup-circles"] && !Shopify.designMode) return;
  try {
    
(function () {
  var CIRCUMFERENCE = 326.73;

  function animateCircle(section) {
    section.querySelectorAll('.counter-single').forEach(function (card) {
      var progressEl = card.querySelector('.progress');
      var countEl = card.querySelector('.count');
      var target = parseInt(progressEl.getAttribute('data-percent'), 10) || 0;
      var duration = 1400;
      var start = null;

      function step(timestamp) {
        if (!start) start = timestamp;
        var elapsed = Math.min(timestamp - start, duration);
        var ease = 1 - Math.pow(1 - elapsed / duration, 3);
        var currentVal = Math.round(ease * target);
        progressEl.style.strokeDashoffset = CIRCUMFERENCE * (1 - ease * target / 100);
        countEl.textContent = currentVal;
        if (elapsed < duration) requestAnimationFrame(step);
        else {
          countEl.textContent = target;
          progressEl.style.strokeDashoffset = CIRCUMFERENCE * (1 - target / 100);
        }
      }

      requestAnimationFrame(step);
    });
  }

  function initSection(section) {
    var triggered = false;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !triggered) {
          triggered = true;
          animateCircle(section);
          observer.disconnect();
        }
      });
    }, { threshold: 0.25 });
    observer.observe(section);
  }

  document.querySelectorAll('.ms-product-countup-circles').forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.ms-product-countup-circles');
    if (section) animateCircle(section);
  });
})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-product-main"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const section = document.querySelector('.ms-product-main');
  const mainMedia = section.querySelector('.main-media');
  const thumbMedia = section.querySelector('.thumb-media');
  const mainWrapper = mainMedia.querySelector('.swiper-wrapper');
  const thumbWrapper = thumbMedia.querySelector('.swiper-wrapper');

  const originalMainHTML = mainWrapper.innerHTML;
  const originalThumbHTML = thumbWrapper.innerHTML;

  // Video/3D slides must survive the per-color image swap below, since that swap
  // rebuilds slides purely from the variant-images metafield (images only), which
  // would otherwise silently drop the video whenever a color swatch is selected.
  function extractNonImageSlides(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var slides = tmp.querySelectorAll('.swiper-slide[data-media-type="video"], .swiper-slide[data-media-type="external_video"], .swiper-slide[data-media-type="model"]');
    return Array.prototype.map.call(slides, function(s) { return s.outerHTML; }).join('');
  }
  const extraMainSlidesHTML = extractNonImageSlides(originalMainHTML);
  const extraThumbSlidesHTML = extractNonImageSlides(originalThumbHTML);

  const dataEl = document.querySelector('.ms-variant-images-json');
  const variantImagesMap = dataEl ? JSON.parse(dataEl.textContent) : null;

  const preloaded = new Set();
  function preloadImages(images) {
    images.forEach(function(img) {
      if (!preloaded.has(img.src)) { new Image().src = img.src; preloaded.add(img.src); }
      if (!preloaded.has(img.thumb)) { new Image().src = img.thumb; preloaded.add(img.thumb); }
    });
  }

  function addAutoplayParams(src) {
    if (!src) return src;
    var sep = src.indexOf('?') === -1 ? '?' : '&';
    var params = 'autoplay=1&mute=1&muted=1&loop=1';
    if (src.indexOf('autoplay=1') !== -1) return src;
    return src + sep + params;
  }

  // Uses swiperMain.activeIndex (a Swiper API value, updated synchronously the
  // instant slideChange fires) rather than the '.swiper-slide-active' CSS class,
  // since with effect:'fade' that class reassignment is tied to the crossfade
  // transition and can lag behind the event by ~300ms, causing play/pause to be
  // applied to the slide you're leaving instead of the one you're on.
  function getActiveSlideEl() {
    if (!swiperMain || !swiperMain.slides) return null;
    return swiperMain.slides[swiperMain.activeIndex] || null;
  }

  function playActiveVideo() {
    var activeSlide = getActiveSlideEl();
    if (!activeSlide) return;

    var video = activeSlide.querySelector('video');
    if (video) {
      video.muted = true;
      video.loop = true;
      var playPromise = video.play();
      if (playPromise && playPromise.catch) { playPromise.catch(function() {}); }
    }

    var iframe = activeSlide.querySelector('iframe');
    if (iframe) {
      var src = iframe.getAttribute('src');
      var newSrc = addAutoplayParams(src);
      if (newSrc !== src) { iframe.setAttribute('src', newSrc); }
    }
  }

  function pauseInactiveVideos() {
    if (!swiperMain || !swiperMain.slides) return;
    var activeIndex = swiperMain.activeIndex;
    Array.prototype.forEach.call(swiperMain.slides, function(slide, i) {
      if (i === activeIndex) return;
      var v = slide.querySelector('video');
      if (v) v.pause();
      var f = slide.querySelector('iframe');
      if (f) {
        var src = f.getAttribute('src');
        if (src) { f.setAttribute('src', src.replace(/([?&])autoplay=1&?/, '$1').replace(/[?&]$/, '')); }
      }
    });
  }

  let swiperMain, swiperThumbs, usingMetaobjectSlides = false, currentColor = null, currentNonColorOption = null;

  function scrollThumbsTo(index) {
    if (!swiperThumbs) return;
    const perView = swiperThumbs.params.slidesPerView;
    const offset = Math.floor(perView / 2);
    swiperThumbs.slideTo(Math.max(0, index - offset));
  }

  function initSwipers() {
    if (swiperThumbs) swiperThumbs.destroy(true, true);
    if (swiperMain) swiperMain.destroy(true, true);

    swiperThumbs = new Swiper('.ms-product-main .thumb-media .swiper', {
      slidesPerView: 5,
      spaceBetween: 5,
      watchSlidesProgress: true,
      breakpoints: {
        768: { slidesPerView: 6, spaceBetween: 10 },
      },
    });

    swiperMain = new Swiper('.ms-product-main .main-media .swiper', {
      loop: false,
      spaceBetween: 0,
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      navigation: {
        nextEl: '.ms-product-main .main-media .swiper-button-next',
        prevEl: '.ms-product-main .main-media .swiper-button-prev',
      },
      thumbs: { swiper: swiperThumbs },
      on: {
        slideChangeTransitionStart: function() {
          pauseInactiveVideos();
          playActiveVideo();
        },
        slideChange: function() {
          scrollThumbsTo(this.activeIndex);
        },
      },
    });

    pauseInactiveVideos();
    playActiveVideo();
  }

  function swapSlides(buildMain, buildThumb) {
    mainMedia.style.opacity = '0';
    thumbMedia.style.opacity = '0';
    mainWrapper.innerHTML = buildMain();
    thumbWrapper.innerHTML = buildThumb();
    initSwipers();
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        mainMedia.style.opacity = '';
        thumbMedia.style.opacity = '';
      });
    });
  }

  function setMetaobjectSlides(images) {
    usingMetaobjectSlides = true;
    swapSlides(
      function() { return images.map(function(img) { return '<div class="swiper-slide"><div class="slide-wrapper"><img src="' + img.src + '" alt="' + img.alt + '"></div></div>'; }).join('') + extraMainSlidesHTML; },
      function() { return images.map(function(img) { return '<div class="swiper-slide"><img src="' + img.thumb + '" alt="' + img.alt + '" loading="lazy"></div>'; }).join('') + extraThumbSlidesHTML; }
    );
  }

  function restoreOriginalSlides() {
    usingMetaobjectSlides = false;
    swapSlides(
      function() { return originalMainHTML; },
      function() { return originalThumbHTML; }
    );
  }

  function syncSliderToSwatch(swatchId) {
    if (!swatchId) return;
    const slides = Array.from(section.querySelectorAll('.main-media .swiper-slide'));
    const index = slides.findIndex(s => s.dataset.swatchId === swatchId);
    if (index === -1) return;
    swiperMain.slideTo(index);
    scrollThumbsTo(index);
  }

  function navigateToSlideByAlt(color, optionValue) {
    var sizePart = optionValue.toLowerCase().replace(/\s+/g, '-');
    var allColorsAlt = 'swatch-all-colors-' + sizePart;
    var colorAlt = ('swatch-' + color + '-' + optionValue).toLowerCase().replace(/\s+/g, '-');
    var slides = Array.from(section.querySelectorAll('.main-media .swiper-slide'));
    var index = -1;
    for (var i = 0; i < slides.length; i++) {
      var img = slides[i].querySelector('img');
      if (!img) continue;
      var alt = img.alt.toLowerCase();
      if (alt === allColorsAlt) { index = i; break; }
      if (index === -1 && alt === colorAlt) { index = i; }
    }
    var target = index !== -1 ? index : 0;
    swiperMain.slideTo(target, 0);
    scrollThumbsTo(target);
  }

  function onColorChange(optionValue, swatchId) {
    if (variantImagesMap && variantImagesMap[optionValue]) {
      currentColor = optionValue;
      preloadImages(variantImagesMap[optionValue]);
      setMetaobjectSlides(variantImagesMap[optionValue]);
      if (currentNonColorOption) {
        var navColor = currentColor;
        var navOption = currentNonColorOption;
        requestAnimationFrame(function() {
          navigateToSlideByAlt(navColor, navOption);
        });
      }
    } else if (currentColor && variantImagesMap && variantImagesMap[currentColor]) {
      currentNonColorOption = optionValue;
      if (!usingMetaobjectSlides) {
        setMetaobjectSlides(variantImagesMap[currentColor]);
        var navColor2 = currentColor;
        requestAnimationFrame(function() {
          navigateToSlideByAlt(navColor2, optionValue);
        });
      } else {
        navigateToSlideByAlt(currentColor, optionValue);
      }
    } else {
      if (usingMetaobjectSlides) restoreOriginalSlides();
      syncSliderToSwatch(swatchId);
    }
  }

  const urlVariantId = new URLSearchParams(window.location.search).get('variant');
  const initialOption = section.dataset.initialOption;
  currentColor = initialOption;
  currentNonColorOption = section.dataset.initialOption2 || null;
  if (variantImagesMap && initialOption && variantImagesMap[initialOption]) {
    preloadImages(variantImagesMap[initialOption]);
  }
  if (urlVariantId && variantImagesMap && initialOption && variantImagesMap[initialOption]) {
    setMetaobjectSlides(variantImagesMap[initialOption]);
  } else {
    initSwipers();
  }

  document.addEventListener('change', function(e) {
    if (e.target.matches('.swatch-input__input, input[type="radio"][data-swatch-id]')) {
      onColorChange(e.target.value, e.target.dataset.swatchId);
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-product-upsell"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ms-product-upsell .swiper').forEach(function(el) {
      new Swiper(el, {
        slidesPerView: 1.25,
        spaceBetween: 20,
        scrollbar: {
          el: el.querySelector('.swiper-scrollbar'),
          draggable: true,
        },
        breakpoints: {
          1000: { slidesPerView: 3 },
          900: { slidesPerView: 2.75 },
          700:  { slidesPerView: 2.15, spaceBetween: 20 },
          550:  { slidesPerView: 1.75, spaceBetween: 15 },
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-video-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.ms-video-slider .swiper').forEach(function(el) {
      new Swiper(el, {
        loop: true,
        slidesPerView: 1.15,
        spaceBetween: 20,
        breakpoints: {
          1024: { slidesPerView: 4 },
          768:  { slidesPerView: 2.25 },
          500:  { slidesPerView: 1.75 }
        },
        pagination: {
          el: el.querySelector('.ms-video-slider .swiper-pagination'),
          type: 'bullets',
          clickable: true
        }
      });
    });


  });

  } catch(e) { console.error(e); }
})();
})();
